import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    template: ` <div
    class="fw-bold mb-1 text-truncate custom-line-height-cell custom-two-line-cell"
  >
    <span
      data-test-selector="three-line-with-title-as-link-description"
      class="text-muted fw-normal"
    >
      {{ value }}
    </span>
  </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductDescriptionCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  value?: string;

  agInit({ value }: ICellRendererParams<unknown, string>): void {
    if (value) this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}
